import { combineReducers } from "redux"
import { number } from "./numberReducer"

const numberReducers = combineReducers({
  number
})

export default numberReducers
